<template>
  <div>
    <el-input
      v-model="input_value"
      v-bind="input_props"
      @keyup.enter.native="handleEnter"
    />
    <div v-if="value.length && tagsNum" class="tags-limit">{{ `（${value.length}/${tagsNum}）` }}</div>
    <div v-if="value.length" :class="{ 'tags-column': direction === 'column' }" class="tags-content mt-5">
      <el-tag
        v-for="(item, i) in value"
        :key="i"
        :class="{ 'tags-item-column': direction === 'column' }"
        class="mr-5 mt-5"
        closable
        :disable-transitions="true"
        @close="handleClose(i)"
      >{{ item }}</el-tag>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormTags',
  model: {
    prop: 'value',
  },
  props: {
    /** 双向绑定值 */
    value: {
      type: Array,
      default: () => [],
    },
    /** 标签展示方向 - row: 水平方向；column：垂直方向 */
    direction: {
      type: String,
      default: 'row',
    },
    /** 是否支持批量输入 */
    multiple: {
      type: Boolean,
      default: true,
    },
    /** 标签数量限制 - 0: 不限制 */
    tagsNum: {
      type: Number,
      default: 0,
    },
    /** 是否显示输入字数统计 */
    showWordLimit: {
      type: Boolean,
      default: false,
    },
    /** 每标签字数最小限制 */
    minlength: {
      type: [Number, null],
      default: null,
    },
    /** 每标签字数最大限制 */
    maxlength: {
      type: [Number, null],
      default: null,
    },
    /** 输入框占位文本 */
    placeholder: {
      type: [String, null],
      default: null,
    },
    /** 是否允许重复标签 */
    isAllowRepeat: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input_value: '',
      input_props: {},
    };
  },
  created() {
    Object.assign(this.input_props, {
      placeholder: this.placeholder || (this.multiple ? '输入文本按回车添加，批量添加多个文本用、分隔' : '输入文本按回车添加'),
      ...((this.showWordLimit && this.maxlength) && { showWordLimit: this.showWordLimit, maxlength: this.maxlength }),
      ...((this.minlength || this.minlength === 0) && { minlength: this.minlength }),
    });
  },
  methods: {
    /** 回车事件 */
    handleEnter() {
      if (!this.input_value.trim()) {
        this.$message.warning('请输入文本！');
        return;
      }
      const tags = (this.multiple ? this.input_value.split('、') : [this.input_value]).map(tag => tag.trim());

      // 标签数量限制
      if (this.tagsNum) {
        if ((this.value.length + tags.length) > this.tagsNum) {
          this.$message.warning(`标签数量超出上限${this.tagsNum}个`);
          return;
        }
      }
      // 不允许重复文本
      if (!this.isAllowRepeat) {
        const repeat_tag = tags.find(tag => this.value.includes(tag));
        if (repeat_tag) {
          this.$message.warning(`存在重复文本${repeat_tag}！`);
          return;
        }
      }
      // 文本最小字数限制
      if (this.minlength || this.minlength === 0) {
        const is_valid = tags.every(tag => tag.length >= this.minlength);
        if (!is_valid) {
          this.$message.warning(`文本字数应不小于${this.minlength}个字！`);
          return;
        }
      }
      // 文本最大字数限制
      if (this.maxlength) {
        const is_valid = tags.every(tag => tag.length <= this.maxlength);
        if (!is_valid) {
          this.$message.warning(`文本字数应不大于${this.maxlength}个字！`);
          return;
        }
      }

      this.value.push(...tags);
      this.input_value = '';
      this.$emit('change', this.value);
    },
    /**
     * 标签移除事件
     * @param {number} index 标签索引
     */
    handleClose(index) {
      this.value.splice(index, 1);
      this.$emit('change', this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.tags-limit {
  text-align: right;
}
.tags-content {
  padding: 5px 10px;
  max-height: 200px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  overflow: auto;
}
.tags-column {
  display: flex;
  flex-direction: column;
  .tags-item-column {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.mt-5 {
  margin-top: 5px;
}
.mr-5 {
  margin-right: 5px;
}
</style>
